import { render, staticRenderFns } from "./CoverLetters.vue?vue&type=template&id=37cc26dd&scoped=true&"
import script from "./CoverLetters.vue?vue&type=script&lang=ts&"
export * from "./CoverLetters.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37cc26dd",
  null
  
)

export default component.exports